<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/QiseO6/tc-custom/9781429901215.jpg?1731797656226" alt="This image is the cover for the book Hotel Riviera"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hotel Riviera
      </h1>
      <p class="bookDescription body article font2">
        <p>American Lola Laforet was swept away in a whirlwind wedding and found herself the chef/owner of the Hotel Riviera. Her life seemed to be a dream come true. But then her husband disappeared one day with nothing more than a wave goodbye. Six months later, Jack Ferrar, an American ex-pat living on his boat, drops anchor in Lola's harbor and teaches her the true meaning of attraction. When various shady people-all claiming ownership of the Hotel Riviera-and the police appear, Lola and Jack have to track down the mysterious Patrick. And along the way, they fall in love. With great food, wonderful sensuality, and lush scenery, Elizabeth Adler holds you under her spell and transports you to one of the most romantic places on earth.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Elizabeth Adler
      </h2>
      
      <p class="authorDescription body article"><P><B>Elizabeth Adler</B> is the internationally acclaimed author of sixteen novels. She lives in Palm Springs, California.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1a06ff9d